<template>
<v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
        <v-card width="600">
            <div class="pa-3" style="background: #3498db; color: white; font-size: 20px">
                내 정보
            </div>
            <v-form>
                <v-container>
                    <v-text-field label="Email" class="purple-input" disabled v-model="email" />

                    <v-text-field class="purple-input" label="User Name" v-model="name" />

                    <v-textarea class="purple-input" label="About Me" v-model="description" />

                    <v-col cols="12" class="text-right">
                        <v-btn color="primary" class="mr-0" @click="updateProfile">
                            업데이트
                        </v-btn>
                    </v-col>
                </v-container>
            </v-form>
        </v-card>
    </v-row>
</v-container>
</template>

<script>
import {
    db,
    auth
} from '@/firebase'
import {
    mapGetters
} from 'vuex'

export default {
    data: () => ({
        loading: false,
        isSNS: false,
        email: '',
        emailReadOnly: false,
        isDuplicatedEmail: true,
        name: '',
        nameReadOnly: false,
        isDuplicatedName: true,
        description: '',
        pw: '',
        confirmPw: '',
        agreement: false,
        showTerms: false,
    }),
    computed: {
        ...mapGetters(['user']),
    },
    mounted() {
        this.email = this.user.email
        this.name = this.user.name
        this.description = this.user.description
    },
    methods: {
        async updateProfile() {
            if (this.name != this.user.name) {
                const duplicatedName = await db.collection('users').where('name', '==', this.name).limit(1).get()

                if (duplicatedName.size > 0) {
                    this.name = this.user.name
                    return this.$toasted.error('이미 존재하는 닉네임입니다.')
                }
            }

            await db.collection('users').doc(this.user.id).update({
                name: this.name,
                description: this.description
            })

            this.$toasted.show("업데이트되었습니다")
        }
    }
}
</script>
